import React from "react";

const OutcomesData = [
  {
    id: 1,
    title: "Master Core Concepts in International Relations:",
    description:
      "Demonstrate a comprehensive understanding of international relations theories and their practical application in global diplomacy.",
  },
  {
    id: 2,
    title: "Develop Advanced Leadership Skills:",
    description:
      "Apply strategic decision-making, negotiation, and governance skills to lead effectively in foreign offices and international organisations.",
  },
  {
    id: 3,
    title: "Address Contemporary Challenges:",
    description:
      "Tackle global issues such as climate diplomacy, migration management, and human rights through innovative and collaborative approaches.",
  },
  {
    id: 4,
    title: "Promote Inclusivity in Diplomacy:",
    description:
      "Integrate gender perspectives and inclusive practices into leadership and governance frameworks.",
  },
  {
    id: 5,
    title: "Engage in Global Networking:",
    description:
      "Build professional relationships with peers, policymakers, and global organisations for sustained collaboration.",
  },
  {
    id: 6,
    title: "Gain Practical Exposure:",
    description:
      "Observe and learn from best practices during study tours to esteemed international institutions and agencies.",
  },
];

const Outcomes = () => {
  const iconUrl = "/essential-icons/verified-svgrepo-com2.svg";
  const backgroundImageUrl =
    "/image-fix/dark-overlay-bg-images/dark-overlayed-bg-2.png"; // Update this with the actual path

  return (
    <div
      className="bg-cover bg-center"
      style={{ backgroundImage: `url(${backgroundImageUrl})` }}
    >
      <div className="mx-auto max-w-6xl md:p-10 p-3 space-y-3">
        <div className="space-y-3">
          <div>
            <p className="text-white font-bold text-lg md:text-xl">Outcomes</p>
          </div>
          <div className="bg-sdbodywhite h-0.5 w-10"></div>
        </div>

        <div className="space-y-3">
          {OutcomesData.map((focus) => (
            <div key={focus.id} className="space-y-2">
              <div className="flex space-x-2 items-center">
                <img src={iconUrl} className="h-5 w-5" alt="icon" />
                <div className=" bg-[#18589D] text-white p-2 border-l-2 border-white">
                  <p>{focus.title}</p>
                </div>
              </div>

              <div className="text-white ml-7 border-l-2 border-white text-sm md:text-base">
                <div className="bg-[#498ED8] p-2">
                  <p>{focus.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Outcomes;
